'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
function getToastPlacement(position, dir) {
  var _logical$dir;
  // Chakra overwrite: changed default position from 'bottom' to 'top-right'.
  var computedPosition = position !== null && position !== void 0 ? position : 'top-right';
  var logicals = {
    'top-start': {
      ltr: 'top-left',
      rtl: 'top-right'
    },
    'top-end': {
      ltr: 'top-right',
      rtl: 'top-left'
    },
    'bottom-start': {
      ltr: 'bottom-left',
      rtl: 'bottom-right'
    },
    'bottom-end': {
      ltr: 'bottom-right',
      rtl: 'bottom-left'
    }
  };
  var logical = logicals[computedPosition];
  return (_logical$dir = logical === null || logical === void 0 ? void 0 : logical[dir]) !== null && _logical$dir !== void 0 ? _logical$dir : computedPosition;
}
exports.getToastPlacement = getToastPlacement;